import { useState } from 'react';
import useReveal from './useReveal';
import Tag from './Tag';
import { skills } from '../data';

const topLine = { accent: '#00e5ff', red: '#ff4d6d', green: '#a8ff3e', '': '#00e5ff' };
const hoverBorder = { accent: 'rgba(0,229,255,0.3)', red: 'rgba(255,77,109,0.3)', green: 'rgba(168,255,62,0.3)', '': 'rgba(0,229,255,0.3)' };

function SkillCard({ icon, title, color, tags, delay }) {
  const [ref, visible] = useReveal();
  const [hov, setHov] = useState(false);
  return (
    <div ref={ref} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ background: '#0f1c24', border: `1px solid ${hov ? hoverBorder[color] || '#1a3040' : '#1a3040'}`, padding: '2rem', position: 'relative', overflow: 'hidden', transition: 'border-color 0.2s, transform 0.25s', transform: visible ? (hov ? 'translateY(-3px)' : 'none') : 'translateY(30px)', opacity: visible ? 1 : 0, transitionDelay: `${delay}ms` }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${topLine[color] || '#00e5ff'}, transparent)`, opacity: hov ? 1 : 0, transition: 'opacity 0.2s' }} />
      <span style={{ fontSize: '1.8rem', marginBottom: '1rem', display: 'block' }}>{icon}</span>
      <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.8rem', color: '#e2f0f5' }}>{title}</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
        {tags.map(t => <Tag key={t.label} label={t.label} color={t.color} />)}
      </div>
    </div>
  );
}

export default function Skills() {
  return (
    <section id="skills" style={{ background: '#0b1318', borderTop: '1px solid #1a3040', borderBottom: '1px solid #1a3040', position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '6rem 3rem' }}>
        <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          02 // Compétences
          <span style={{ flex: 1, maxWidth: 80, height: 1, background: '#00e5ff', opacity: 0.4 }} />
        </div>
        <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: '3rem', color: '#e2f0f5' }}>
          Stack technique <span style={{ color: '#00e5ff' }}>orientée IA industrielle</span>
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
          {skills.map((s, i) => <SkillCard key={s.title} {...s} delay={i * 60} />)}
        </div>
      </div>
    </section>
  );
}
